import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Navbar from './Navbar.jsx';
import LoadingComponent from '../../../shared/LoadingComponent';
import SelectedAudienceHeader from './SelectedAudienceHeader.jsx';
import NewTileComponent from '../../../shared/TileComponent/NewTileComponent.jsx';
import i18n from '../../../app/i18n';

const displayCreationDate = date => {
  const splitDate = date.split('T')[0].split('-');
  const dateObject = new Date(Date.UTC(splitDate[0], splitDate[1]));
  return dateObject.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
  });
};

const Tiles = ({ tiles, copyTile, user, openTileModal }) =>
  tiles.map(tile => (
    <NewTileComponent
      key={tile.id}
      {...tile}
      copyTile={copyTile}
      user={user}
      date={displayCreationDate(tile.updatedAt)}
      copyButtonDisplay={true}
      viewButtonDisplay={false}
      tileContainerClass="explore"
      tileThumblinkClass="tile_thumb_link"
      tileThumblinkOnClick={() => {
        openTileModal(tile.id);
      }}
      tileShowPath={null}
      shadowOverlay={true}
    />
  ));

const shouldShowCopyAudience = props =>
  !(
    props.selectedAudience.ongoing ||
    props.user.isGuestUser ||
    props.user.isEndUser
  );

const navTabText = ongoing =>
  ongoing ? i18n.t('explore:ongoing') : i18n.t('explore:campaign');

const SelectedAudienceComponent = props => (
  <Wrapper>
    <Navbar
      navName={navTabText(props.selectedAudience.ongoing)}
      showButtons={true}
      navbarRedirect={props.navbarRedirect}
      copyAllTiles={props.copyAllTiles}
      copyText={props.selectedAudience.copyText}
      showCopyAudience={shouldShowCopyAudience(props)}
    />
    <SelectedAudienceHeader
      audienceName={props.selectedAudience.name}
      description={props.selectedAudience.description}
    />
    <GridWrapper>
      <TilesGrid>
        <Tiles
          tiles={props.tiles}
          copyTile={props.copyTile}
          user={props.user}
          openTileModal={props.openTileModal}
        />
      </TilesGrid>
      {props.scrollLoading && <LoadingComponent />}
    </GridWrapper>
  </Wrapper>
);

SelectedAudienceComponent.propTypes = {
  selectedAudience: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    ongoing: PropTypes.bool,
    copyText: PropTypes.string,
  }),
  tiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      thumbnail: PropTypes.string,
      updatedAt: PropTypes.string,
      headline: PropTypes.string,
    }),
  ),
  user: PropTypes.shape({
    isGuestUser: PropTypes.bool,
    isEndUser: PropTypes.bool,
  }),
  navbarRedirect: PropTypes.func,
  copyAllTiles: PropTypes.func,
  copyTile: PropTypes.func,
  scrollLoading: PropTypes.bool,
  openTileModal: PropTypes.func,
};

export default SelectedAudienceComponent;

const GridWrapper = styled.div`
  width: 100%;
`;

const TilesGrid = styled.div`
  display: grid;
  max-width: 1148px;
  width: 100%;
  padding: 24px;
  grid-gap: 24px;
  margin: 0 auto;
  grid-template-columns: repeat(auto-fill, 257px);
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
